const endpoint = '/cart-service/api/external/negotiations';

export const negotiationsContext = {
  get: `${endpoint}/`,
  getById: `${endpoint}/{id}`,
  updateSellerPrice: `${endpoint}/{id}`,
  changeDecision: `${endpoint}/{id}/decision`,
};
